import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem, ListItemText } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { PostObj } from "../../Models/Post";
import { GetColors, GetPosts } from "../../Services/Posts";
import "./Poste.css";
import { useTranslation } from "react-i18next";

const ListPost: React.FunctionComponent<{}> = (props) => {

  const [loading, setLoading] = useState(true);
  const [listPosts, setListPosts] = useState<PostObj[]>();
  const [listColors, setListColors] = useState<any>();
  const [type, setType] = useState<any>("poster");
  const [theme, setTheme] = useState<any>("all");
  const [model, setModel] = useState<any>("all");
  const [change, setChange] = useState<Boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [dataLenght, setDataLenght] = useState<any>();
  const [isSpinner, setIsSpinner] = useState<boolean>(true);
  const { t } = useTranslation();

  let navigate = useNavigate();

  useEffect(() => {
    GetColors().then((resp) => {
      setLoading(false)
      setListColors(resp)
    }).catch((error) => {
      console.log("error")
    })
    GetPosts({ type: type, theme: theme, model: model, page: 1, perpage: 12 }).then((data) => {
      setPage(Math.ceil(data.total / 12))
      setDataLenght(data.total)
      setIsSpinner(false)
      setLoading(false)
      setListPosts(data.posters)
    }).catch((error) => {
      console.log("error")
    })
  }, [type, theme, change]);

  const handleChangePagination = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    GetPosts({ type: type, theme: theme, model: model, page: value, perpage: 12 }).then((data) => {
      setPage(Math.ceil(data.total / 12))
      setListPosts(data.posters)
    }).catch(err => {
      // setIsError(true)
      // setShowMessage("Error");
    })

    // setTimeout(() => {
    //   setIsError(false);
    // }, 3000);
  };

  const HandleChangeType = (event: any) => {
    setType(event.target.value);
    setPage(1);
    setChange(!change)
  }

  const HandleChangeModel = (event: any) => {
    setModel(event.target.value);
    setPage(1);
    setChange(!change)
  }

  const HandleChangeTheme = (event: any) => {
    setTheme(event.target.value);
    setPage(1);
    setChange(!change)
  }

  const GeneratePost = (obj: any) => {

    navigate(`/generate-poster`, { state: obj })
  }

  return loading ? (<div className="container-xxl flex-grow-1 container-p-y"> Loading ...</div>) : (
    <div className="container-xxl flex-grow-1">
      <div className="row mt-3">
        <div className="col-md-12 d-flex align-items-center justify-content-center position-relative header-title">
          <a className="buuton-next border-trans marg-right-16 back-EEF2FF border-9 position-absolute start-0" href="/properties">
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 14L13 7" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 14L13 7" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 14H22.3333" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 14H22.3333" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 14L13 21" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 14L13 21" stroke="black" strokeOpacity="0.2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <div className=" text-center">
            <h1 className="title-24 mb-3">{t("listingVideo.posterTemplates")}</h1>
            <p className="para-16 color-39393B">{t("listingVideo.descPosters")}</p>
          </div>
        </div>
      </div>

      <div className=" posts  card-bottom">
        <div className="row mb-4 mt-4">
          <div className="col-md-3 mb-2" >
            <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("listingVideo.selectType")} </label>
            <FormControl size="small" fullWidth>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                className="custom-select"
                onChange={HandleChangeType}
                value={type}
              >
                <MenuItem value={"poster"}>{t("listingVideo.poster")}</MenuItem>
                <MenuItem value={"reel"}>{t("listingVideo.reel")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-md-3 mb-2" >
            <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("listingVideo.selectModel")} </label>
            <FormControl size="small" fullWidth>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                className="custom-select"
                onChange={HandleChangeModel}
                value={model}
              >
                <MenuItem value={"all"}>{t("listingVideo.all")}</MenuItem>
                <MenuItem value={"just listed"}>{t("listingVideo.justListed")}</MenuItem>
                <MenuItem value={"just sold"}>{t("listingVideo.justSold")}</MenuItem>
                <MenuItem value={"testimonial"}>{t("listingVideo.testimonial")}</MenuItem>
                <MenuItem value={"team"}>{t("listingVideo.team")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-md-3 mb-2">
            <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("listingVideo.selectTheme")} </label>
            <FormControl size="small" fullWidth>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                className="custom-select"
                value={theme}
                onChange={HandleChangeTheme}
              >
                <MenuItem value={"all"} key={"all"}>{t("listingVideo.all")}</MenuItem>
                {listColors && listColors.map((color: any, index: any) => {
                  return <MenuItem value={color} key={index}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          backgroundColor: color,
                          marginRight: '10px',
                          border: '1px solid #000',
                        }}
                      ></div>
                      {color}
                    </div>
                  </MenuItem>
                })}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className="row">
          {listPosts && listPosts.map((post: any, index: any) => {
            return <div className="col-md-4 mb-3" key={index} >
              <div className="card-post">
                <img src={post.cover} className="img-post" onClick={() => GeneratePost(post)} />
                <button type="button" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 mt-3" onClick={() => GeneratePost(post)}>
                  {t("listingVideo.use")}</button>
              </div>
            </div>
          })}
        </div>
        <div className="d-flex justify-content-center padd-15-30 mb-4">
          {dataLenght == 0 && isSpinner == false && <h3 className="empty mt-4">{t("propertiesPage.No")}  {type == "poster" ? "Posters" : "Reels"}</h3>}

          {isSpinner == true && <div className="row justify-content-center">
            <div className="col-auto">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          }

          {isSpinner == false && <Pagination count={page} variant="outlined" shape="rounded" style={{ marginTop: "25px" }} onChange={handleChangePagination} />}
        </div>
      </div>
    </div>
  )
}
export default ListPost;